var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-component"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.setValue($event.target.checked)}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }